import { type FC, memo } from 'react';
import StandardJackpot from '../../StandardJackpot';
import type { StandardJackpotProps } from '../../../types/jackpot.types';

import styles from './PremiumLink.module.css';

const PremiumLinkJackpot: FC<StandardJackpotProps> = (props) => {
  const premiumLinkIcons = {
    panel: '/group_premium_link/panel',
    grand: '/group_premium_link/grand',
    major: '/group_premium_link/major',
    minor: '/group_premium_link/minor',
    mini: '',
  };

  return (
    <StandardJackpot
      {...props}
      icons={premiumLinkIcons}
      className={styles.premiumLinkTheme}
    />
  );
};

export default memo(PremiumLinkJackpot);
